import React, { useEffect, useState } from "react";
import { isMobile } from "../../../../utils/helper";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { DatePicker, Input, Select } from "antd";
import "./GroupFilters.css";
import dayjs from "dayjs";
import IconContainer from "../../../../CommonComponents/IconContainer";
import { FilterIcon } from "../../../../utils/icons";
import {
  GROUPS_ADOPTION,
  GROUPS_OWNER,
  GROUPS_STAGE,
} from "../../../../constants/superadmin/groups";

const GroupFilters = ({
  filters,
  handleSearchInputChange,
  handleDropdownChange,
  clubs,
  leagues,
  countries,
  handleDatePickerChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const [localDate, setLocalDate] = useState(
    filters.createdOn ? dayjs.unix(filters.createdOn) : null
  );

  return (
    <div>
      {isMobile() ? (
        <div
          className="superadmin-groups-filters-header"
          onClick={toggleExpand}
          style={isExpanded ? { borderRadius: "0%" } : undefined}
        >
          <span>Filters</span>
          {isExpanded ? (
            <UpOutlined style={{ marginLeft: "auto" }} />
          ) : (
            <DownOutlined style={{ marginLeft: "auto" }} />
          )}
        </div>
      ) : null}

      {(isExpanded || !isMobile()) && (
        <div className="superadmin-groups-filters-container">
          <div>
            <Input
              placeholder="Search Group Name"
              prefix={<SearchOutlined />}
              style={{ width: isMobile() ? "100%" : "15rem" }}
              onChange={(e) => handleSearchInputChange(e.target.value)}
            />
          </div>

          <div className="superadmin-groups-filters">
            <Select
              className="superadmin-groups-filter-input"
              placeholder="Club"
              listHeight={300}
              popupMatchSelectWidth={false}
              options={[{ value: null, label: "Club" }, ...clubs]}
              value={filters?.clubId}
              onChange={(val) => handleDropdownChange("clubId", val)}
            />

            <Select
              className="superadmin-groups-filter-input"
              placeholder="League"
              listHeight={300}
              popupMatchSelectWidth={false}
              options={[{ value: null, label: "League" }, ...leagues]}
              value={filters?.leagueId}
              onChange={(val) => handleDropdownChange("leagueId", val)}
            />

            <Select
              className="superadmin-groups-filter-input"
              placeholder="Country"
              listHeight={300}
              popupMatchSelectWidth={false}
              options={[{ value: null, label: "Country" }, ...countries]}
              value={filters?.country}
              onChange={(val) => handleDropdownChange("country", val)}
            />

            <Select
              className="superadmin-groups-filter-input"
              placeholder="Status"
              listHeight={300}
              popupMatchSelectWidth={false}
              options={[
                { value: null, label: "Status" },
                ...GROUPS_STAGE.map((status) => ({
                  value: status,
                  label: status,
                })),
              ]}
              value={filters?.status}
              onChange={(val) => handleDropdownChange("status", val)}
            />

            <Select
              className="superadmin-groups-filter-input"
              placeholder="Adoption"
              listHeight={300}
              popupMatchSelectWidth={false}
              options={[
                { value: null, label: "Adoption" },
                ...GROUPS_ADOPTION.map((adoption) => ({
                  value: adoption,
                  label: adoption,
                })),
              ]}
              value={filters?.adoption}
              onChange={(val) => handleDropdownChange("adoption", val)}
            />

            <Select
              className="superadmin-groups-filter-input"
              placeholder="Owner"
              listHeight={300}
              popupMatchSelectWidth={false}
              options={[
                { value: null, label: "Owner" },
                ...GROUPS_OWNER.map((owner) => ({
                  value: owner,
                  label: owner,
                })),
              ]}
              value={filters?.owner}
              onChange={(val) => handleDropdownChange("owner", val)}
            />

            <DatePicker
              style={{ minWidth: "12rem", maxWidth: "12rem" }}
              tabIndex="2"
              value={localDate}
              onChange={(date) => {
                setLocalDate(date);
                handleDatePickerChange(date ? date.startOf("day").unix() : 0);
              }}
              placeholder="Created On"
              className="form-control form-control-sm col"
              size={10}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupFilters;
